import { useCallback, useState } from 'react';

export const useDebounce = (callback: (...args: any[]) => void, wait: number) => {
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  const shouldCallCallback = (previousTime: number) => {
    return Date.now() - previousTime >= wait;
  };

  const startTimer = (cb: () => void) => {
    return setTimeout(cb, wait);
  };

  const debouncedFunction = useCallback(
    (...args: any[]) => {
      if (timer) {
        clearTimeout(timer);
      }

      const newTimer = startTimer(() => {
        callback(...args);
      });

      setTimer(newTimer);
    },
    [callback, timer]
  );

  return debouncedFunction;
};